module.exports = __webpack_public_path__ + "img/Grafiker.0248939a.jpg";